import {Component, OnInit, ViewChild} from '@angular/core';
import {SafeResourceUrl} from "@angular/platform-browser";
import {BasePageComponent} from "../../base-page.component";
import {AuthService} from "../../services/auth.service";
import {
  AnagraficaDto,
  AnagraficaUtenteCandidature,
  AnagraficaUtentePortalePagineCompilate,
  CandidatureGetListViewModel
} from "../../models/anagrafica.models";
import {RegistryService} from "../../services/domain/registry.service";
import {ConfirmationService} from "primeng/api";
import {JobPostService} from "../../services/domain/jobpost.service";
import {AnnunciInEvidenza} from "../../models/annunci.models";
import { StudyService } from 'src/app/services/domain/study.service';
import {DocumentService} from "../../services/domain/document.service";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers : [RegistryService, ConfirmationService, JobPostService, StudyService, DocumentService]
})
export class DashboardComponent extends BasePageComponent  implements OnInit {

  constructor(private registryService : RegistryService,
              private jobPostService : JobPostService,
              private documentService : DocumentService) {
    super();

  }
  @ViewChild('profilePhoto') profilePhotoFile : any;
  public profileImageUrl : SafeResourceUrl | null = null;
  public profileName : string  = "";
  public registryDto : AnagraficaDto = new AnagraficaDto();
  public candidatureFilterModel : CandidatureGetListViewModel = new CandidatureGetListViewModel();
  public lstCandidature : AnagraficaUtenteCandidature[] = [];
  public lstJobPostEvidence : AnnunciInEvidenza[] = [];
  public jobPostSelected : AnnunciInEvidenza = new AnnunciInEvidenza();
  public showDetailsDialog : boolean = false;
  public headerDetailsDialog : string = "";
  public showBtnCandidate : boolean = false;
  public registryCompletedPages : AnagraficaUtentePortalePagineCompilate = new AnagraficaUtentePortalePagineCompilate();
  public percCompleted : number = 0;
  public showValueBar : boolean = true;
  public baseImagePath : string = "";
  public customAvatarSize : string = "";
  public showBtnRedirectSections : boolean = false;
  public profileSex : string = "";


  ngOnInit(): void {
    this.customAvatarSize = '50%';
    this.getRegistryDetail();
    this.getJobPostEvidence();
    this.getCompletedPages();
    this.authService.getUserPhoto().then((value) => {
      this.profileImageUrl = value;
    });
    if (AuthService.LoggedUser)
      this.profileName = AuthService.LoggedUser.name ?? "";

    this.baseImagePath = this.authService.baseImagePath;
  }
  public getRegistryDetail(){
    this.asyncCall(() => this.registryService.getRegistryDetail(), response => {
      this.registryDto = response.Item || new AnagraficaDto();
      if(this.registryDto.IndirizzoResidenza == this.registryDto.IndirizzoDomicilio)
        this.registryDto.ResidenzaCombaciaConDomicilio = true;
      else
        this.registryDto.ResidenzaCombaciaConDomicilio = false;
      this.profileSex = this.registryDto.Sesso;
      this.getJobPostProfileCandidate();
    });
  }

  public getJobPostProfileCandidate(){
    this.candidatureFilterModel.IdAnagraficaUtente = this.registryDto.IdAnagraficaUtente;
    this.asyncCall(() => this.registryService.candidatureGetList(this.candidatureFilterModel), response => {
      this.lstCandidature = response.Items || [];
    });
  }

  public getJobPostEvidence(){
    this.asyncCall(() => this.jobPostService.getAnnunciInEvidenza(), response => {
      this.lstJobPostEvidence = response.Items || [];
    });
  }
  public showDetails(idAnnuncio : number, evidence : boolean){
    this.headerDetailsDialog = 'Dettaglio annuncio';
    this.showDetailsDialog = true;
    this.jobPostSelected.IdCommessaAnnuncio = idAnnuncio;
    this.showBtnCandidate = evidence;
  }
  public getCompletedPages(){
    this.asyncCall(() => this.registryService.getRegistryCompletedPages(), response => {
      this.registryCompletedPages = response.Item || new AnagraficaUtentePortalePagineCompilate();
    });
  }
  public onhideModal(){
    this.jobPostSelected = new AnnunciInEvidenza();
  }
  public closeModal(closeModal : boolean){
    this.showDetailsDialog = closeModal;
    this.getJobPostProfileCandidate();
    this.getJobPostEvidence();
  }

}

